import { TabContext, TabList } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import type React from "react";
import type { Graph, Test } from "../../../types";

interface TestDetailsTabsProps {
  tab: string;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  children: React.ReactNode;
  test: Test | undefined;
  depGraph: Graph;
  variants: Test[];
}

export function TestDetailsTabs({
  tab,
  onTabChange,
  children,
  test,
  depGraph,
  variants,
}: TestDetailsTabsProps) {
  return (
    <TabContext value={tab}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList onChange={onTabChange} aria-label="Test details tabs" variant="scrollable">
          <Tab label="Description" value="intent" />
          <Tab label="Details" value="details" />
          <Tab label={`Variables (${test?.variables?.length ?? 0})`} value="variables" />
          <Tab label={`Dependencies (${depGraph.edges.length ?? 0})`} value="deps" />
          <Tab label="Runs" value="runs" />
          <Tab
            label={`Data Assets (${test?.available_data_asset_ids?.length ?? 0})`}
            value="data-assets"
          />
          <Tab label="Graph" value="graph" />
          <Tab label="Analysis" value="anal" />
          <Tab label={`Variants (${variants?.length ?? 0})`} value="variants" />
          <Tab label="Matrix" value="matrix" />
          <Tab label="Advanced" value="advanced" />
        </TabList>
      </Box>
      {children}
    </TabContext>
  );
}
